import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { Callback } from 'Src/types/utilTypes'
import {
	ArticleModel,
	KindTypeModel,
	ProjectModel,
	projectNS,
	projectSlice,
	ResponseCatalogWithQuery,
} from 'Pages/knowledge'
import { RequestParams } from 'Models'

export type ArticleState = {
	data: ResponseCatalogWithQuery<ArticleModel>
	article: ArticleModel
	requestParams: RequestParams
	currentUrlVideo: string
}

export const articleInitialState: ArticleState = {
	data: new ResponseCatalogWithQuery<ArticleModel>(),
	article: null,
	requestParams: new RequestParams(),
	currentUrlVideo: null,
}

export namespace articleNS {
	export type getAllArticle = PayloadAction<{ id?: number; params?: RequestParams }>
	export type setAllArticle = PayloadAction<ResponseCatalogWithQuery<ArticleModel>>
	export type resetArticle = PayloadAction<null>
	export type getOneArticle = PayloadAction<{ idProject: number; idArticle: number }>
	export type viewArticle = PayloadAction<{
		project: string | number
		article: string | number
		isPreview?: boolean
	}>
	export type setOneArticle = PayloadAction<ArticleModel>
	export type clearArticle = PayloadAction
	export type createOneArticle = PayloadAction<{
		data: ArticleModel
		idProject: number
		callback?: Callback
	}>
	export type createOneVideo = PayloadAction<{ data: ArticleModel; idProject: number }>
	export type updateArticle = PayloadAction<{
		data: ArticleModel
		idProject: number
		idArticle?: number
		callback?: Callback
	}>
	export type updateOneVideo = PayloadAction<{ data: ArticleModel; idProject: number; id: number }>
	export type updateArticleState = PayloadAction<{
		data: ArticleModel
		idProject: number
		idArticle: number
		callback?: Callback
	}>
	export type deleteArticle = PayloadAction<{
		idProject: number
		idArticle: number
		kind: KindTypeModel
		callback?: Callback
	}>
	export type recoverArticle = PayloadAction<{
		idProject: number
		idArticle: number
		kind: KindTypeModel
		callback?: Callback
	}>
	export type searchArticle = PayloadAction<{
		params: RequestParams
		clear?: boolean
		idProject?: number
		callback?: Callback
	}>
	export type getUrlVideo = PayloadAction<string>
	export type setUrlVideo = PayloadAction<string>
	export type clearUrlVideo = PayloadAction
	export type setArticlesRequestParams = PayloadAction<RequestParams>
	export type getOneVideo = PayloadAction<{ video: ArticleModel }>
}

export const articleSlice = createSlice({
	name: 'article',
	initialState: articleInitialState,
	reducers: {
		getAllArticle: (state, action: articleNS.getAllArticle) => {
			state.data = new ResponseCatalogWithQuery<ProjectModel>()
			state.requestParams = new RequestParams()
		},
		setAllArticle: (state, action: articleNS.setAllArticle) => {
			state.data = action.payload
		},
		viewArticle: (state, action: articleNS.viewArticle) => {
			state.article = null
		},
		setOneArticle: (state, action: articleNS.setOneArticle) => {
			state.article = action.payload
		},
		clearArticle: (state, action: articleNS.clearArticle) => {
			state.article = null
		},
		setUrlVideo: (state, action: articleNS.setUrlVideo) => {
			state.currentUrlVideo = action.payload
		},
		clearUrlVideo: (state, action: articleNS.clearUrlVideo) => {
			state.currentUrlVideo = articleInitialState.currentUrlVideo
		},
		setArticlesRequestParams: (state, action: articleNS.setArticlesRequestParams) => {
			state.requestParams = action.payload
		},
		resetArticle: (state, action: articleNS.resetArticle) => {
			const { query, ...rest } = state.data
			state.data = { ...rest, query: null }
		},
		createOneArticle: (state, action: articleNS.createOneArticle) => {},
		createOneVideo: (state, action: articleNS.createOneVideo) => {},
		updateArticle: (state, action: articleNS.updateArticle) => {},
		updateOneVideo: (state, action: articleNS.updateOneVideo) => {},
		updateArticleState: (state, action: articleNS.updateArticleState) => {},
		deleteArticle: (state, action: articleNS.deleteArticle) => {},
		recoverArticle: (state, action: articleNS.recoverArticle) => {},
		searchArticle: (state, action: articleNS.searchArticle) => {},
		getUrlVideo: (state, action: articleNS.getUrlVideo) => {},
		getOneVideo: (state, action: articleNS.getOneVideo) => {},
		getOneArticle: (state, action: articleNS.getOneArticle) => {},
	},
	extraReducers: {
		[projectSlice.actions.setAllProject.type]: (state, action: projectNS.setAllProject) => {
			const { query, ...rest } = state.data
			state.data = { ...rest, query: null }
		},
	},
})
